import React, { useEffect, useState } from "react";
import "./Header.css";
import "../../assets/css/app.css";
import paytechlogo from "../../assets/imgs/logo.svg";
import { Link } from "react-router-dom";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen((p) => !p);
  const closeMenu = () => setIsMenuOpen(false);


  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuOpen]);

 
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className={`ptHeader ${isMenuOpen ? "menu-open" : ""}`}>
      <div className="maxW">
        <nav className="ptNav" aria-label="Main">
          <div className="ptNvtop">
            <div className="ptLft">
              <Link
                to="/"
                className="ptLogo"
                onClick={closeMenu}
                aria-label="PayTech Advisor Home"
              >
                <img src={paytechlogo} alt="PayTech-Advisor-Logo" />
              </Link>
            </div>

            <div className="ptRight">
              <Link to="/about-us">ABOUT US</Link>
              <Link to="/contact-us" className="contBtn">
                CONTACT US
              </Link>
              
            </div>

            <button
              className={`ptToggle ${isMenuOpen ? "is-active" : ""}`}
              aria-label="Toggle navigation"
              aria-expanded={isMenuOpen}
              aria-controls="ptMobileMenu"
              onClick={toggleMenu}
              type="button"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </nav>
      </div>

      <nav className="ptNvBTm" role="navigation" aria-label="Services">
        <Link to="/payment-strategy-and-advisory">PAYMENT STRATEGY & ADVISORY</Link>
        <Link to="/tech-and-cloud-solution">TECH & CLOUD SOLUTIONS</Link>
        <Link to="/business-consultancy">BUSINESS CONSULTANCY</Link>
        <Link to="/marketing">360° MARKETING</Link>
      </nav>

   
      <div
        id="ptMobileMenu"
        className="ptMobileMenu"
        aria-hidden={!isMenuOpen}
      
      >
        <div className="ptMobileInner">
          <Link to="/payment-strategy-and-advisory" onClick={closeMenu}>
            PAYMENT STRATEGY & ADVISORY
          </Link>
          <Link to="/tech-and-cloud-solution" onClick={closeMenu}>
            TECH & CLOUD SOLUTIONS
          </Link>
          <Link to="/business-consultancy" onClick={closeMenu}>
            BUSINESS CONSULTANCY
          </Link>
          <Link to="/marketing" onClick={closeMenu}>
            360° MARKETING
          </Link>

          <div className="ptMobileDivider" />

          <Link to="/about-us" onClick={closeMenu}>
            ABOUT US
          </Link>
          <Link to="/contact-us" onClick={closeMenu} className="contBtn">
            CONTACT US
          </Link>
          
        </div>
      </div>
    </header>
  );
}
